// import { useId } from "react";
// import { useGetAllSessionsQuery } from "../../services/submissionPeriod/api";
// import { SESSION_KINDS } from "../../util/constants";
// import EditAdminDates from "./Dates/Edit";
// import { Mui } from "@osu/react-ui";

// const Wrapper = (props) => <Mui.Paper sx={{ p: 5 }} component="section" {...props} />

function AllSessions() {
  return false
  // const { data = [] } = useGetAllSessionsQuery({ type: SESSION_KINDS.FGC });
  // const baseId = useId();
  // if (!Array.isArray(data) || !data?.length) return false;
  // const years = [...new Set(data?.map(({ year }) => year))];

  // return years.map((year, idx) => {
  //   return (
  //       <EditAdminDates
  //         key={`all-sessions-${year}-${idx}`}
  //         baseId={baseId}
  //         year={year}
  //         component={Wrapper}
  //       />
  //   );
  // });
}

export default AllSessions;
